export const formats = [
  'bold',
  'italic',
  'underline',
  'list',
  'bullet',
  'ordered',
  'align',
  'background',
  'size',
];

export const modules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ align: '' }, { align: 'center' }, { align: 'justify' }],
    [{ list: 'bullet' }, { list: 'ordered' }],
    [
      { background: ['', '#fff3bf', '#ffd6a5', '#caffbf', '#a0c4ff', '#bdb2ff'] },
      { size: ['small', false, 'large', 'huge'] },
    ],
    ['clean'],
  ],
  clipboard: { matchVisual: false },
};

export default {};
